exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".imitate-refer{position:relative;cursor:pointer}.imitate-refer input{pointer-events:none}.imitate-refer i{position:absolute;margin-top:-12px;line-height:24px;top:50%}.imitate-refer i.canzhao{color:#999;right:0;font-size:14px;width:24px;padding-left:4px}.imitate-refer i.empty{font-size:16px;right:24px;color:#ccc;display:none}.imitate-refer i.empty:hover{color:#505766}.imitate-refer:hover i.empty{display:block}.imitate-refer:hover input{border-color:rgba(80,87,102,.8)}", ""]);

// exports
